import { IMenu } from "const/menus";

export const findLandingPage = (menus: IMenu[], screenCode: string) => {
  return menus.flatMap((menu) => (menu.subMenu ? menu.menus : menu)).find((menu) => menu?.code === screenCode);
};
